<template>
    <transition name="dialog-t" class="vx-overlay">
        <div
            v-if="active_x"
            ref="vxOverlayRef"
            :class="{ 'con-vs-dialog--active': active_x }"
            class="vs-component con-vs-dialog"
            :style="{ zIndex: this.activeZIndex }"
        >
            <div class="vs-dialog-dark" @click="handleClickOutside" />
            <div ref="dialogx" class="dialog-container" :class="classes_x">
                <slot></slot>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'vx-overlay',
    props: {
        active: {
            type: Boolean,
            default: false
        },
        persistent: {
            type: Boolean,
            default: false
        },
        parent: {
            default: null
        },
        centerContent: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        active: {
            handler: function (val) {
                this.tryInsertBody()
                this.$nextTick(() => {
                    this.getMaxZIndex()
                })
            },
            immediate: true
        },
        parent_x: {
            handler: function (val, previous) {
                this.tryRemoveBody(previous)

                this.tryInsertBody()
            },
            immediate: true
        }
    },
    data() {
        return {
            stackMinZIndex: 52005
        }
    },
    computed: {
        active_x: {
            get() {
                return this.active
            },
            set(v) {
                this.$emit('update:active', v)
            }
        },
        parent_x() {
            if (!this.parent) {
                return document.body
            }
            if (this.parent.$el) {
                return this.parent.$el
            }
            return this.parent
        },
        classes_x() {
            if (!this.centerContent) {
                return ''
            }
            return 'flex w-full h-full items-center justify-center'
        },
        activeZIndex() {
            if (typeof window === 'undefined') return 0

            const content = this.stackElement || this.$refs.content

            const index = this.getMaxZIndex(this.stackExclude || [content]) + 2

            if (index == null) return index

            return parseInt(index)
        }
    },
    methods: {
        rebound() {
            var child = this.$children.first()
            child.classList.add('locked')
            setTimeout(() => {
                child.classList.remove('locked')
            }, 100)
        },
        tryInsertBody() {
            if (this.active) {
                this.$nextTick(() => {
                    let elx = this.$refs.vxOverlayRef
                    this.parent_x.appendChild(elx)
                })
            }
        },
        handleClickOutside(e) {
            if (this.persistent) {
                this.rebound()
                return
            }
            this.close()
        },
        close() {
            this.active_x = false
            this.$emit('close')
        },
        getMaxZIndex(exclude = []) {
            const baseElem = this.$el
            const zis = [this.stackMinZIndex, this.getZIndex(baseElem)]
            const activeElements = [...document.getElementsByClassName('con-vs-dialog')]
            for (let index = 0; index < activeElements.length; index++) {
                if (!exclude.includes(activeElements[index])) {
                    zis.push(this.getZIndex(activeElements[index]))
                }
            }
            return Math.max(...zis)
        },
        getZIndex(el) {
            if (!el || el.nodeType !== Node.ELEMENT_NODE) return 0
            const index = +window.getComputedStyle(el).getPropertyValue('z-index')
            if (!index) return this.getZIndex(el.parentNode)
            return index
        },
        tryRemoveBody(parent) {
            this.$nextTick(() => {
                parent = parent || this.parent_x
                let elx = this.$refs.vxOverlayRef
                if (elx && parent.contains(elx)) {
                    parent.removeChild(elx)
                }
            })
        }
    },
    beforeDestroy() {
        // close the left open prompt
        this.tryRemoveBody()
    }
    // mounted() {
    //     this.tryInsertBody()
    // }
}
</script>

<style lang="scss" scoped>
.dialog-container {
    position: relative;
    z-index: 11;
    width: 100%;
    height: 100%;
    display: flex;
    pointer-events: none;

    &:deep(*) {
        pointer-events: auto;
    }
}
</style>
